import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  sv: {
    translation: {
      // General
      app_name: 'Förvaltningen',
      loading: 'Laddar...',
      save: 'Spara',
      cancel: 'Avbryt',
      delete: 'Radera',
      edit: 'Redigera',
      add: 'Lägg till',
      search: 'Sök',
      close: 'Stäng',
      back: 'Tillbaka',
      submit: 'Skicka',
      confirm: 'Bekräfta',
      
      // Auth
      login: 'Logga in',
      logout: 'Logga ut',
      email: 'E-post',
      enter_email: 'Ange din e-postadress',
      send_code: 'Skicka kod',
      enter_code: 'Ange kod',
      verify: 'Verifiera',
      code_sent: 'En kod har skickats till din e-post',
      invalid_code: 'Ogiltig kod',
      
      // Navigation
      dashboard: 'Översikt',
      issues: 'Ärenden',
      properties: 'Fastigheter',
      apartments: 'Lägenheter',
      residents: 'Boende',
      orders: 'Arbetsordrar',
      settings: 'Inställningar',
      api_keys: 'API-nycklar',
      
      // Issues
      report_issue: 'Anmäl fel',
      new_issue: 'Nytt ärende',
      my_issues: 'Mina ärenden',
      all_issues: 'Alla ärenden',
      issue_title: 'Rubrik',
      issue_description: 'Beskrivning',
      issue_category: 'Kategori',
      urgency_level: 'Akutnivå',
      status: 'Status',
      attachments: 'Bilagor',
      upload_files: 'Ladda upp filer',
      
      // Categories
      plumbing: 'VVS/Rör',
      electrical: 'El',
      heating: 'Värme',
      other: 'Övrigt',
      
      // Status
      open: 'Öppet',
      in_progress: 'Pågående',
      waiting: 'Väntar',
      resolved: 'Löst',
      closed: 'Stängt',
      
      // Urgency
      urgency_1: 'Låg',
      urgency_2: 'Normal',
      urgency_3: 'Hög',
      urgency_4: 'Brådskande',
      urgency_5: 'Akut',
      
      // Emergency
      emergency_warning: 'Vid akuta situationer, ring:',
      emergency_contacts: 'Jourkontakter',
      
      // Properties
      property_name: 'Fastighetsnamn',
      address: 'Adress',
      property_designation: 'Fastighetsbeteckning',
      
      // Apartments
      apartment_number: 'Lägenhetsnummer',
      floor: 'Våning',
      dwelling_type: 'Boendetyp',
      area: 'Yta (kvm)',
      
      // Dwelling types
      apartment: 'Lägenhet',
      house: 'Hus',
      townhouse: 'Radhus',
      studio: 'Etta',
      
      // Users
      name: 'Namn',
      phone: 'Telefon',
      personal_number: 'Personnummer',
      role: 'Roll',
      
      // Roles
      resident: 'Boende',
      admin: 'Admin',
      board_member: 'Styrelsemedlem',
      subcontractor: 'Underleverantör',
      
      // Orders
      create_order: 'Skapa arbetsorder',
      subcontractor_name: 'Namn',
      subcontractor_email: 'E-post',
      instructions: 'Instruktioner',
      due_date: 'Deadline',
      pending: 'Väntande',
      accepted: 'Accepterad',
      completed: 'Slutförd',
      rejected: 'Avvisad',
      completion_notes: 'Anteckningar',
      
      // Stats
      total_issues: 'Totalt antal ärenden',
      open_issues: 'Öppna ärenden',
      emergency_issues: 'Akuta ärenden',
      resolved_issues: 'Lösta ärenden',
      
      // Messages
      issue_created: 'Ärendet har skapats',
      issue_updated: 'Ärendet har uppdaterats',
      order_sent: 'Arbetsorder skickad',
      saved_successfully: 'Sparat',
      error_occurred: 'Ett fel uppstod',
      welcome: 'Välkommen',
      
      // Search
      search_placeholder: 'Sök ärenden, boende, fastigheter...',
      no_results: 'Inga resultat hittades',
      no_orders: 'Inga arbetsordrar',
      
      // Order confirmation
      order_details: 'Orderdetaljer',
      accept_order: 'Acceptera order',
      complete_order: 'Slutför order',
      reject_order: 'Avvisa order',
      add_documentation: 'Lägg till dokumentation',
    }
  },
  en: {
    translation: {
      // General
      app_name: 'Förvaltningen',
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      close: 'Close',
      back: 'Back',
      submit: 'Submit',
      confirm: 'Confirm',
      
      // Auth
      login: 'Log in',
      logout: 'Log out',
      email: 'Email',
      enter_email: 'Enter your email address',
      send_code: 'Send code',
      enter_code: 'Enter code',
      verify: 'Verify',
      code_sent: 'A code has been sent to your email',
      invalid_code: 'Invalid code',
      
      // Navigation
      dashboard: 'Dashboard',
      issues: 'Issues',
      properties: 'Properties',
      apartments: 'Apartments',
      residents: 'Residents',
      orders: 'Work Orders',
      settings: 'Settings',
      api_keys: 'API Keys',
      
      // Issues
      report_issue: 'Report Issue',
      new_issue: 'New Issue',
      my_issues: 'My Issues',
      all_issues: 'All Issues',
      issue_title: 'Title',
      issue_description: 'Description',
      issue_category: 'Category',
      urgency_level: 'Urgency Level',
      status: 'Status',
      attachments: 'Attachments',
      upload_files: 'Upload files',
      
      // Categories
      plumbing: 'Plumbing',
      electrical: 'Electrical',
      heating: 'Heating',
      other: 'Other',
      
      // Status
      open: 'Open',
      in_progress: 'In Progress',
      waiting: 'Waiting',
      resolved: 'Resolved',
      closed: 'Closed',
      
      // Urgency
      urgency_1: 'Low',
      urgency_2: 'Normal',
      urgency_3: 'High',
      urgency_4: 'Urgent',
      urgency_5: 'Emergency',
      
      // Emergency
      emergency_warning: 'For emergencies, call:',
      emergency_contacts: 'Emergency Contacts',
      
      // Properties
      property_name: 'Property Name',
      address: 'Address',
      property_designation: 'Property Designation',
      
      // Apartments
      apartment_number: 'Apartment Number',
      floor: 'Floor',
      dwelling_type: 'Dwelling Type',
      area: 'Area (sqm)',
      
      // Dwelling types
      apartment: 'Apartment',
      house: 'House',
      townhouse: 'Townhouse',
      studio: 'Studio',
      
      // Users
      name: 'Name',
      phone: 'Phone',
      personal_number: 'Personal Number',
      role: 'Role',
      
      // Roles
      resident: 'Resident',
      admin: 'Admin',
      board_member: 'Board Member',
      subcontractor: 'Subcontractor',
      
      // Orders
      create_order: 'Create Work Order',
      subcontractor_name: 'Name',
      subcontractor_email: 'Email',
      instructions: 'Instructions',
      due_date: 'Due Date',
      pending: 'Pending',
      accepted: 'Accepted',
      completed: 'Completed',
      rejected: 'Rejected',
      completion_notes: 'Notes',
      
      // Stats
      total_issues: 'Total Issues',
      open_issues: 'Open Issues',
      emergency_issues: 'Emergency Issues',
      resolved_issues: 'Resolved Issues',
      
      // Messages
      issue_created: 'Issue created',
      issue_updated: 'Issue updated',
      order_sent: 'Work order sent',
      saved_successfully: 'Saved',
      error_occurred: 'An error occurred',
      welcome: 'Welcome',
      
      // Search
      search_placeholder: 'Search issues, residents, properties...',
      no_results: 'No results found',
      
      // Order confirmation
      order_details: 'Order Details',
      accept_order: 'Accept Order',
      complete_order: 'Complete Order',
      reject_order: 'Reject Order',
      add_documentation: 'Add Documentation',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'sv',
    fallbackLng: 'sv',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
